import { useRecordContext } from "react-admin";
import { DateTime } from "luxon";
import { IconButton } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import { Student } from "../providers/studentsProvider";
import { useDialog } from "../hooks/useDialog";
import { PostponeDunningProcessDialog } from "../dialogs/PostponeDunningProcessDialog";

export function PostponeDunningProcessButton({ onSuccess }: { onSuccess: () => void }) {
  const student = useRecordContext<Student>();
  const { dialogProps, openDialog } = useDialog();
  const { dunningProcess } = student || {};
  const now = DateTime.now();
  const isProcessPostponed = dunningProcess?.postponedUntil && dunningProcess.postponedUntil > now;
  const isStudentPostponed = student?.dunningPostponedUntil && student.dunningPostponedUntil > now;
  if (isProcessPostponed || isStudentPostponed) return null;
  return (
    <>
      <IconButton onClick={openDialog} data-testid="postpone-dunning-button">
        <HistoryIcon sx={{ color: "text.secondary" }} />
      </IconButton>
      <PostponeDunningProcessDialog {...dialogProps} student={student} onSuccess={onSuccess} />
    </>
  );
}
